<template>
<svg class="cnm-icon" width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="24" cy="24.8667" r="24" fill="white"/>
<path d="M32 18.8667L21 29.8667L16 24.8667" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>